import "./categories.css";
import { useState, useEffect } from "react";
function Categories(props) {
  function getRobotique() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(true);
    props.setCarte(false);
    props.setIot(false);
    props.setModules(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Robotique");
  }
  function getCarte() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(false);
    props.setCategory("Cartes de développement");
    props.setCarte(true);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);

  }
  function getIot() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setModules(false);
    props.setRobotique(false);
    props.setCarte(false);
    props.setIot(true);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("IOT");
  }
  function getDrone() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setModules(false);
    props.setRobotique(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(true);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Drone & Aeromodele");
  }
  function getCapteurs() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setModules(false);
    props.setRobotique(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(true);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Capteurs");
  }
  function getMoteursAndDivers() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(true);
    props.setElectronique(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Moteurs & Drivers");
  }
  function getModules() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(true);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Modules");
  }
  function getAfficheurs() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setAfficheurs(true);
    props.setCategory("Afficheurs");
  }
  function getElectronique() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(true);
    props.setAfficheurs(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Composants électroniques");
  }
  function getConnecteur() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setAfficheurs(false);
    props.setConnecteurs(true);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Connecteurs et cables");
  }
  function getAlimentation() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setAfficheurs(false);
    props.setConnecteurs(false);
    props.setAlimentation(true);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Alimentation & Batteries");
  }
  function getOutillages() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setAfficheurs(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(true);
    props.setMachines(false);
    props.setCategory("Outillages & Mesures");
  }
  function getMachines() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setAfficheurs(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(true);
    props.setCategory("Machines 3D et cnc");
  }
  function getKits() {
    props.setKits(true);
    props.setAutomatisme(false);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setAfficheurs(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Kits");
  }
  function getSmartHome() {
    props.setKits(false);
    props.setAutomatisme(false);
    props.setSmartHome(true);
    props.setRobotique(false);
    props.setModules(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setAfficheurs(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Smart Home");
  }
  function getAutomatisme() {
    props.setKits(false);
    props.setAutomatisme(true);
    props.setSmartHome(false);
    props.setRobotique(false);
    props.setModules(false);
    props.setCarte(false);
    props.setIot(false);
    props.setDrone(false);
    props.setCapteurs(false);
    props.setAfficheurs(false);
    props.setMoteursAndDivers(false);
    props.setElectronique(false);
    props.setAfficheurs(false);
    props.setConnecteurs(false);
    props.setAlimentation(false);
    props.setOutillages(false);
    props.setMachines(false);
    props.setCategory("Automatisme");
  }
  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };
function changeCat(event){
  console.log(event.target.value)
  if (event.target.value === "Cartes de développement") {
    getCarte()
  } else if (event.target.value === "Robotique") {
    getRobotique()
  
} else if (event.target.value === "IOT") {
  getIot()
}
else if (event.target.value === "Drone & Aeromodele") {
  getDrone()
}
else if (event.target.value === "Machines 3D et cnc") {
  getMachines()
}
else if (event.target.value === "Moteurs & Drivers") {
  getMoteursAndDivers()
}
else if (event.target.value === "Capteurs") {
  getCapteurs()
}
else if (event.target.value === "Modules") {
  getModules()
}
else if (event.target.value === "Afficheurs") {
  getAfficheurs()
}
else if (event.target.value === "Composants électroniques") {
  getElectronique()
}
else if (event.target.value === "Connecteurs et cables") {
  getConnecteur()
}
else if (event.target.value === "Alimentation & Batteries") {
  getAlimentation()
}
else if (event.target.value === "Outillages & Mesures") {
  getOutillages()
}
else if (event.target.value === "Kits") {
  getKits()
}
else if (event.target.value === "Smart Home") {
  getSmartHome()
}
else if (event.target.value === "Automatisme") {
  getAutomatisme()
}
};

  useEffect(() => {
    window.addEventListener("resize", detectSize);
    // console.log("quantity" + windowDimenion.winWidth);

    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimenion]);
  if (windowDimenion.winWidth > 800) {
    return (
      <div className="c">
        <div className="catTitle">Catégories</div>
        <div className="semiyellowLine">
          <div className="firsthorline"></div>
          <div className="secondhorline"></div>
        </div>
        <div className="listCategories">
        <div
            className="elementcat"
            onClick={getSmartHome}
            style={{
              color:
                props.category === "Smart Home"
                  ? "#001130 "
                  : "black",
              fontWeight:
                props.category === "Smart Home" ? "800" : "300",

              textDecoration:
                props.category === "Smart Home"
                  ? "underline"
                  : "none",
            }}
          >
            Smart Home
          </div>
          <div
            className="elementcat"
            onClick={getKits}
            style={{
              color:
                props.category === "Kits"
                  ? "#001130 "
                  : "black",
              fontWeight:
                props.category === "Kits" ? "800" : "300",

              textDecoration:
                props.category === "Kits"
                  ? "underline"
                  : "none",
            }}
          >
            Kits
          </div>
          <div
            className="elementcat"
            onClick={getCarte}
            style={{
              color:
                props.category === "Cartes de développement"
                  ? "#001130 "
                  : "black",
              fontWeight:
                props.category === "Cartes de développement" ? "800" : "300",

              textDecoration:
                props.category === "Cartes de développement"
                  ? "underline"
                  : "none",
            }}
          >
            Cartes De Développement
          </div>
          <div
            className="elementcat"
            onClick={getRobotique}
            style={{
              color:
                props.category === "Robotique"
                  ? "#001130 "
                  : "black",
              fontWeight: props.category === "Robotique" ? "800" : "300",

              textDecoration:
                props.category === "Robotique" ? "underline" : "none",
            }}
          >
            Robotique
          </div>
          <div
            className="elementcat"
            onClick={getIot}
            style={{
              color: props.category === "IOT" ? "#001130 " : "black",
              fontWeight: props.category === "IOT" ? "800" : "300",

              textDecoration:
                props.category === "IOT" ? "underline" : "none",
            }}
          >
            IOT
          </div>
          <div
            className="elementcat"
            onClick={getDrone}
            style={{
              color:
                props.category === "Drone & Aeromodele" ? "#001130 " : "black",
              fontWeight: props.category === "Drone & Aeromodele" ? "800" : "300",

              textDecoration:
                props.category === "Drone & Aeromodele" ? "underline" : "none",
            }}
          >
            Drone & Aeromodele
          </div>
          <div
            className="elementcat"
            onClick={getMachines}
            style={{
              color:
                props.category === "Machines 3D et cnc" ? "#001130 " : "black",
              fontWeight: props.category === "Machines 3D et cnc" ? "800" : "300",

              textDecoration:
                props.category === "Machines 3D et cnc" ? "underline" : "none",
            }}
          >
            Machines 3D et cnc
          </div>
          <div
            className="elementcat"
            onClick={getAutomatisme}
            style={{
              color:
                props.category === "Automatisme"
                  ? "#001130 "
                  : "black",
              fontWeight:
                props.category === "Automatisme" ? "800" : "300",

              textDecoration:
                props.category === "Automatisme"
                  ? "underline"
                  : "none",
            }}
          >
            Automatisme
          </div>
          <div
            className="elementcat"
            onClick={getModules}
            style={{
              color:
                props.category === "Modules"
                  ? "#001130 "
                  : "black",
              textDecoration:
                props.category === "Modules"
                  ? "underline"
                  : "none",
              fontWeight:
                props.category === "Modules" ? "800" : "300",
            }}
          >
            Modules
          </div>
          <div
            className="elementcat"
            onClick={getCapteurs}
            style={{
              color: props.category === "Capteurs" ? "#001130 " : "black",
              fontWeight: props.category === "Capteurs" ? "800" : "300",

              textDecoration:
                props.category === "Capteurs" ? "underline" : "none",
            }}
          >
            Capteurs
          </div>
          <div
            className="elementcat"
            onClick={getMoteursAndDivers}
            style={{
              color:
                props.category === "MMoteurs & Drivers" ? "#001130 " : "black",
              fontWeight: props.category === "Moteurs & Drivers" ? "800" : "300",

              textDecoration:
                props.category === "Moteurs & Drivers" ? "underline" : "none",
            }}
          >
            Moteurs & Drivers
          </div>

          <div
            className="elementcat"
            onClick={getAfficheurs}
            style={{
              color:
                props.category === "Afficheurs" ? "#001130 " : "black",
              fontWeight: props.category === "Afficheurs" ? "800" : "300",

              textDecoration:
                props.category === "Afficheurs" ? "underline" : "none",
            }}
          >
            Afficheurs
          </div>

          <div
            className="elementcat"
            onClick={getElectronique}
            style={{
              color:
                props.category === "Composants électroniques" ? "#001130 " : "black",
              fontWeight: props.category === "Composants électroniques" ? "800" : "300",

              textDecoration:
                props.category === "Composants électroniques" ? "underline" : "none",
            }}
          >
            Composants électroniques
          </div>
           <div
            className="elementcat"
            onClick={getConnecteur}
            style={{
              color:
                props.category === "Connecteurs et cables" ? "#001130 " : "black",
              fontWeight: props.category === "Connecteurs et cables" ? "800" : "300",

              textDecoration:
                props.category === "Connecteurs et cables" ? "underline" : "none",
            }}
          >
            Connecteurs et cables
          </div>
          <div
            className="elementcat"
            onClick={getAlimentation}
            style={{
              color:
                props.category === "Alimentation & Batteries" ? "#001130 " : "black",
              fontWeight: props.category === "Alimentation & Batteries" ? "800" : "300",

              textDecoration:
                props.category === "Alimentation & Batteries" ? "underline" : "none",
            }}
          >
            Alimentation & Batteries
          </div>
          <div
            className="elementcat"
            onClick={getOutillages}
            style={{
              color:
                props.category === "Outillages & Mesures" ? "#001130 " : "black",
              fontWeight: props.category === "Outillages & Mesures" ? "800" : "300",

              textDecoration:
                props.category === "Outillages & Mesures" ? "underline" : "none",
            }}
          >
            Outillages & Mesures
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="mobileCategory">
        <label forhtml="category" className="labelCatMobile"> category:</label>
        <select name="category" id="category" onChange={changeCat} className="selectcatMobile">
          <option value="Cartes de développement"  >Cartes De Développement</option>
          <option value="Robotique"  >Robotique</option>
          <option value="IOT" >IOT</option>
          <option value="Drone & Aeromodele"   >Drone & Aeromodele</option>
          <option value="Machines 3D et cnc">Machines 3D et cnc</option>
          <option value="Modules" >Modules</option>
          <option value="Capteurs"  >Capteurs</option>
          <option value="Moteurs & Drivers"  >Moteurs & Divers</option>
          <option value="Afficheurs"  >Afficheurs</option>
          <option value="Composants électroniques"  >Composants électroniques</option>
        </select>
      </div>
    );
  }
}
export default Categories;
